module.exports = __webpack_public_path__ + "img/fwxy.ddc7d4d6.png";